import React from "react";
import "./search.scss";
import { connect } from "react-redux";
import { fetchSearch } from "../../store/search/actions";
import { Link } from "react-router-dom";

const Search = ({ searchMovies, fetchSearch }) => {
  const linkFromSearch = () => {
    fetchSearch("");
  };

  const searchResults = () => {
    if (searchMovies) {
      return (
        <ul className="search-result">
          {searchMovies.map(item => {
            return (
              <Link
                key={item.id}
                className="link-search"
                to={`/details/${item.id}`}
                onClick={() => linkFromSearch(item.id)}
              >
                <li className="search-result-item">{item.title}</li>
              </Link>
            );
          })}
        </ul>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="search-wrap">
      <input
        className="search"
        placeholder="Search your things"
        onChange={e => fetchSearch(encodeURI(e.target.value))}
      />
      {searchResults()}
    </div>
  );
};

const mapState = state => {
  return {
    searchMovies: state.search.searchMovies
  };
};

const mapDispatch = dispatch => {
  return {
    fetchSearch: query => fetchSearch(dispatch, query)
  };
};

export default connect(mapState, mapDispatch)(Search);
